import { useEffect, useRef, useState } from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { readCompanyLogo } from "../../components/ProjectReportLogo";

// Separate presentation images; never replace the study's company logo.
export default function CommercialProposalImage({ value, onChange, field, label, isGreek, disabled }) {
  const tr = (el, en) => isGreek ? el : en;
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const request = useRef(0);
  const latestChange = useRef(onChange);
  latestChange.current = onChange;
  useEffect(() => () => { request.current += 1; }, []);
  useEffect(() => {
    if (disabled) { request.current += 1; setLoading(false); }
  }, [disabled]);
  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    const id = ++request.current;
    setError(""); setLoading(true);
    try {
      const image = await readCompanyLogo(file);
      if (id === request.current) latestChange.current({ [field]: image.logoDataUrl, [`${field}_name`]: image.logoFileName });
    } catch (err) {
      if (id === request.current) setError(tr("Επιλέξτε έγκυρη εικόνα PNG ή JPEG, έως 2 MB και 4096 pixel ανά πλευρά.", err.message));
    } finally {
      if (id === request.current) setLoading(false);
    }
  };
  return <Stack spacing={1}>
    {value[field] && <Box component="img" src={value[field]} alt={label}
      sx={{ width: "100%", maxHeight: 260, objectFit: "contain", bgcolor: "white" }} />}
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      <Button component="label" variant="outlined" disabled={disabled || loading}>
        {loading ? tr("Ανάγνωση εικόνας…", "Reading image…") : tr(`Επιλογή: ${label}`, `Choose: ${label}`)}
        <input aria-label={tr(`Ανέβασμα: ${label}`, `Upload: ${label}`)} type="file" accept="image/png,image/jpeg"
          hidden disabled={disabled || loading} onChange={upload} />
      </Button>
      {value[field] && <Button disabled={disabled || loading} onClick={() => {
        setError(""); onChange({ [field]: "", [`${field}_name`]: "" });
      }}>{tr(`Αφαίρεση: ${label}`, `Remove: ${label}`)}</Button>}
    </Stack>
    {value[`${field}_name`] && <Typography variant="caption" sx={{ overflowWrap: "anywhere" }}>{value[`${field}_name`]}</Typography>}
    <Typography variant="caption" color="text.secondary">{tr("PNG ή JPEG, έως 2 MB και 4096 pixel ανά πλευρά. Η εικόνα εμφανίζεται μόνο στην αναλυτική εμπορική προσφορά. Δεν απαιτείται νέα προσομοίωση.",
      "PNG or JPEG, up to 2 MB and 4096 pixels per side. Used only in the detailed commercial proposal. No new simulation is required.")}</Typography>
    {error && <Alert severity="error">{error}</Alert>}
  </Stack>;
}
